import { proxy } from 'comlink';
/**
 * Returns a transferred object if the tested object is a Comlink proxy,
 * otherwise returns the object unchanged.
 */
/*
export function transferIfNeeded<T extends Transferable>(
    testedObject: unknown,
    obj: T,
): T {
    if (isComlinkProxy(testedObject)) {
        return transfer(obj, [obj]);
    }
    return obj;
}
*/
/**
 * Check if an object is likely a Comlink proxy.
 * Comlink proxies are function-based Proxy objects - they use a function
 * as the proxy target so methods can be called on them.
 */
export function isComlinkProxy(obj) {
    // Comlink proxies are functions (typeof === 'function')
    // wrapped in a Proxy, with no own properties
    if (typeof obj !== 'function') {
        return false;
    }
    // Comlink proxy functions have no own properties
    // and their toString returns the native function string
    const hasNoOwnProps = Object.keys(obj).length === 0;
    const toStringResult = Function.prototype.toString.call(obj);
    const isNativeProxy = toStringResult.includes('native code');
    return hasNoOwnProps && isNativeProxy;
}
/**
 * Returns a Comlink proxy of obj if the tested object is a Comlink proxy,
 * otherwise returns the object unchanged.
 * Use this to conditionally wrap callbacks when you don't know if you're
 * communicating through Comlink or directly.
 */
export function proxyIfNeeded(testedObject, obj) {
    if (isComlinkProxy(testedObject)) {
        return proxy(obj);
    }
    return obj;
}
